import React from "react";
import { FluentProvider } from "@fluentui/react-provider";
import { webLightTheme } from "@fluentui/react-theme";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import initLocalization from "../i18n/config";

/* global HTMLElement, Office, document, module, require */

const rootElement: HTMLElement = document.getElementById("container") as HTMLElement;
const root = createRoot(rootElement);

/* Render application after Office initializes */
Office.onReady(() => {
  initLocalization(Office.context.displayLanguage);
  root.render(
    <FluentProvider theme={webLightTheme}>
      <App />
    </FluentProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(NextApp);
  });
}
